import i18next from 'i18next';
import React from 'react';

import { DownloadLink, DownloadLinkLabel, ModalDescription } from './styledComponents';

const PartnerInvoiceErrorsModal = ({ onDownload }) => (
  <div>
    <ModalDescription>
      {i18next.t('ORDERS.ORDERS.PARTNER_INVOICE_ERRORS_MODAL_DESCRIPTION')}
    </ModalDescription>
    <DownloadLink onClick={onDownload}>
      <img alt="download-icon" src="/images/inpulse/file-download-black-small.svg" />
      <DownloadLinkLabel>
        {i18next.t('ORDERS.ORDERS.PARTNER_INVOICE_DOWNLOAD_ERRORS')}
      </DownloadLinkLabel>
    </DownloadLink>
  </div>
);

export default PartnerInvoiceErrorsModal;
